import { render, staticRenderFns } from "./ExperienciasImperdibles.vue?vue&type=template&id=6a90121e&scoped=true"
import script from "./ExperienciasImperdibles.vue?vue&type=script&lang=js"
export * from "./ExperienciasImperdibles.vue?vue&type=script&lang=js"
import style0 from "./ExperienciasImperdibles.vue?vue&type=style&index=0&id=6a90121e&prod&scoped=true&lang=css"
import style1 from "./ExperienciasImperdibles.vue?vue&type=style&index=1&id=6a90121e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a90121e",
  null
  
)

export default component.exports